module.exports = __webpack_public_path__ + "static/img/logo93.4aa38bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo93.png
// module id = VZAl
// module chunks = 1